import React from 'react';
import { ScrapbookFile } from '@/api';
import classNames from 'classnames';
import { fixColor } from '@/utils/color-utils';

interface ColourChipProps {
  content: {
    displayName: string;
    seasons: {
      categoryDisplayName: string;
    };
    hexCode: string;
    effect?: string;
    pageTitle?: string;
    tpxCode?: string;
    ralCode?: string;
    coatedCode?: string;
    ncsCode?: string;
    id: string;
    pageId?: string;
  };
  file: ScrapbookFile;
  viewMode?: 'grid' | 'list';
}

const ColourChip: React.FC<ColourChipProps> = ({ content, viewMode = 'grid' }) => {
  if (viewMode === 'list') {
    return (
      <>
        <div className="flex h-[160px] items-center gap-4 border border-gray-200 bg-white">
          <div className="h-full w-[315px] cursor-pointer border-r border-gray-300 bg-gray-50 px-[21px] py-0">
            <div
              className={classNames(
                'flex h-full items-center justify-center bg-cover bg-center bg-no-repeat',
                content.effect === 'Metallic' && 'bg-metallic',
                content.effect === 'Lustre' && 'bg-lustre',
                content.effect === 'Chrome' && 'bg-chrome',
              )}
              style={{
                backgroundColor: fixColor(content.hexCode),
              }}
            />
          </div>
          <div className="relative bottom-10 flex-1 cursor-pointer">
            <h4 className="font-bold text-gray-900">{content.displayName}</h4>
            <div className="mt-1 text-xs text-black">
              <div className="line-clamp-3 overflow-hidden">{content.seasons?.categoryDisplayName}</div>
            </div>
          </div>
        </div>
      </>
    );
  }

  return (
    <>
      <div draggable className="cursor-move hover:opacity-80">
        <div className="relative">
          <div className="overflow-hidden">
            <div
              className="relative h-0 w-full cursor-pointer overflow-hidden border border-b-0 border-gray-300 bg-white"
              style={{ paddingBottom: '73.25%', paddingTop: '30px' }}
            >
              <div
                className={classNames(
                  'absolute inset-0 bg-cover bg-center bg-no-repeat',
                  content.effect === 'Metallic' && 'bg-metallic',
                  content.effect === 'Lustre' && 'bg-lustre',
                  content.effect === 'Chrome' && 'bg-chrome',
                )}
                style={{
                  backgroundColor: fixColor(content.hexCode),
                }}
              />
            </div>
            <div className="h-[120px] cursor-pointer border border-gray-300 bg-white p-3 text-sm">
              <h4 className="mb-1 text-sm font-bold">{content.displayName}</h4>
              <div className="text-xs leading-tight text-gray-600">
                <div className="line-clamp-3 overflow-hidden">{content.seasons?.categoryDisplayName}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ColourChip;
